import axiosServices from "../utils/axios";

import type { HistoryRecord } from "../utils/types/type-helper";

interface historyResponse{
  data:HistoryRecord[] | null;
}

export const fetchHistoryList= async(jobId: String)=>{
    const response = await axiosServices.get<historyResponse>(`/jobs/${jobId}/history`)
    return response?.data?.data;
}